import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(loc.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then((r) => {
        signIn(r.data);
        window.history.replaceState(null, "", "/app");
        nav("/app", { replace: true });
      })
      .catch(() => nav("/login", { replace: true }));
  }, [loc.hash, nav, signIn]);
  return null;
}
